// extracted by mini-css-extract-plugin
export default {"transactionLink":"_uO6UN0TEVAX21LaKZH0"};